import { Switch, Route } from 'react-router-dom';
import React from 'react';
import { buildRoute, isRouterPage } from './utils';
import { Routable } from './interfaces';

function checkSlash(route?: string, prefix?: string) {
  // Skip check for wildcard routes to reduce noisy console warnings
  if (route && route !== '*' && !route.startsWith('/')) {
    console.warn(
      `Route "${route}" on prefix "${prefix ?? ''}" is missing leading slash`
    );
  }
}

interface RouteSetProps {
  routables: Routable[];
  prefix?: string;
  isAuthenticated?: boolean;
}

export const RouteSet: React.FC<RouteSetProps> = ({
  routables,
  prefix,
  isAuthenticated,
}) => {
  return (
    <Switch>
      {routables.map((r) => {
        checkSlash(r.route, prefix);
        const route = buildRoute(r.route, prefix);

        return (
          <Route key={r.route} exact={r.exact} path={route}>
            {isRouterPage(r) ? (
              r.content
            ) : (
              <RouteSet
                routables={r.pages}
                prefix={route}
                isAuthenticated={isAuthenticated}
              />
            )}
          </Route>
        );
      })}
    </Switch>
  );
};
